<template>
  <div>
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div><br/>
    <h4>Loading...</h4>
    </div>
    <form class="form-horizontal mb-0" >
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-button-success addNewBtn btn-btm-0 width-auto" label="New" @click.prevent="openBasic" icon="pi pi-plus"/>
        </div>
      </div>
      <Dialog header="Measurement Unit"  :modal="true" :visible.sync="displayBasic" :closable=false :style="{width: '50vw'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
              <label for="name">Name<span style="color:red">*</span></label>
              <InputText v-model.trim="name"  id="name" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="shortName">Short Name<span style="color:red">*</span></label>
               <InputText v-model.trim="shortName" id="shortName"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="des">Description</label>
               <TextArea v-model.trim="description" id="des" rows="5"/>
            </div>
           </div>
        <template #footer>
          <Button class="p-button-raised" @click.prevent="addMeasurementUnit" :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-info" @click.prevent="addAndNewMeasurementUnit" v-if="!editing"
            label="Add & New"/>
          <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
export default {
  name: 'measurementUnit',
  data() {
    return {
      name: '',
      shortName: '',
      description: '',
      measurementUnit: {},
      editing: false,
      id: '',
      loading: false,
      displayBasic: false
    }
  },
  methods: {
    async addMeasurementUnit() {
      let response = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Measurement unit name cannot be empty!', life: 10000})
        return
      }
      if (this.shortName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Short name cannot be empty!', life: 10000})
        return
      }
      let measurementUnit = {
        name: this.name,
        shortName: this.shortName,
        description: this.description,
        id: this.id
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createMesurementUnit', measurementUnit)
        this.$emit('set_data_unit', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateMesurementUnit', measurementUnit)
        this.loading = false
      }
      this.responseMessage(response)
      this.closeBasic()
    },
    async addAndNewMeasurementUnit() {
      let response = ''
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Measurement unit name cannot be empty!', life: 10000})
        return
      }
      let measurementUnit = {
        name: this.name,
        shortName: this.shortName,
        description: this.description,
        id: this.id
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createMesurementUnit', measurementUnit)
      this.loading = false
      this.responseMessage(response)
      this.closeBasic()
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    cancel() {
      this.closeBasic()
      this.reset()
    },
    reset() {
      this.name = ''
      this.description = ''
      this.shortName = ''
      this.editing = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    editMeasurementUnit(data) {
      this.editing = true
      this.name = data.name
      this.shortName = data.shortName
      this.description = data.description
      this.id = data.id
      this.openBasic()
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    TextArea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// measurementUnitDialog.vue?b6013ade